import React from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {BaseStatusTag} from '@modifi/ui'
import {useTranslation} from '@modifi/plugin-i18n'
import {airBlue} from '@modifi/colors'

const propTypes = {
  children: PropTypes.node,
}
const defaultProps = {
  children: null,
}

export type InProgressProps = InferPropTypes<typeof propTypes, typeof defaultProps>

const InProgress: React.FC<InProgressProps> = ({children, ...restProps}) => {
  const {t} = useTranslation('argus')
  return (
    <BaseStatusTag
      backgroundColor={airBlue}
      dataIdent="shipment-status-tag"
      data-status="in-progress"
      iconComponent={null}
      {...restProps}
    >
      {children || t('shipment-status.in-progress')}
    </BaseStatusTag>
  )
}

InProgress.propTypes = propTypes
InProgress.defaultProps = defaultProps

export default InProgress
